import { useTheme } from "../App";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="fixed bottom-24 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 gold-glow"
      style={{
        backgroundColor: theme === "dark" ? "var(--mm-gold)" : "var(--mm-surface)",
        border: `2px solid var(--mm-gold)`,
        boxShadow: "0 4px 20px rgba(47, 216, 168, 0.3)"
      }}
      aria-label={theme === "dark" ? "Passa al tema chiaro" : "Passa al tema scuro"}
      data-testid="theme-toggle"
    >
      {theme === "dark" ? (
        <Sun size={24} color="#000" />
      ) : (
        <Moon size={24} style={{ color: "var(--mm-gold)" }} />
      )}
    </button>
  );
}
